import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { NavService } from '../nav.service';

@Component({
  selector: 'ae-nav-bar',
  templateUrl: './nav-bar.component.html',
  styles: []
})
export class NavBarComponent implements OnInit {
  @ViewChild('navbar') public navbar: ElementRef;
  @ViewChild('header') public header: ElementRef;
  constructor(private navService: NavService, private render: Renderer2) { }

  ngOnInit() {
    this.navService.position$.subscribe(this.changeNavBar.bind(this));
  }

  changeNavBar(position: string) {
    if (position === 'top') {
      this.render.setStyle(this.navbar.nativeElement, 'background-color', 'transparent');
      this.render.setStyle(this.header.nativeElement, 'color', 'white');
    } else {
      this.render.setStyle(this.navbar.nativeElement,  'background-color', 'gainsboro');
      this.render.setStyle(this.header.nativeElement, 'color', '#28a745');
    }
  }

}
